export default [
    {
        path: 'relatorio-paciente-atendido',
        component: () => import(
            /* webpackChunkName: 'farmacia-relatorio-paciente-atendido' */
            '@/views/farmacia/relatorio-paciente-atendido/Index'
        ),
        redirect: 'relatorio-paciente-atendido/index',
        children: [
            {
                name: 'farmacia-relatorio-paciente-atendido-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-relatorio-paciente-atendido' */
                    '@/views/farmacia/relatorio-paciente-atendido/List'
                ),
            },
        ]
    }
]